module.exports = __webpack_public_path__ + "img/3687.0d9e3b1e.webp";